import React, { Component } from 'react';
import 'leaflet/dist/leaflet.css';
import { Map, TileLayer } from 'react-leaflet';

import data from '../../assets/data_gamers';
import data2 from '../../assets/data_gamers_weurope';
import Markers from './VenueMarkers';

class MapView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentLocation: { lat: 52.52437, lng: 18.0 },
      zoom: 5,
    }
  }

  render() {
    const { currentLocation, zoom } = this.state;

    return (
      <Map center={currentLocation} zoom={zoom}>
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution="&copy; <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
        />

        <Markers venues={data.venues}/>
        <Markers venues={data2.venues}/>
      </Map>
    );
  }
}

export default MapView;
/* https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png
https://cartodb-basemaps-{s}.ssl.fastly.net/rastertiles/voyager_nolabels/{z}/{x}/{y}.png
*/